<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="800"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="断网"
      @ok="handleSubmit"
    >
      <a-row>
        <a-form
          class="iotplt-compact-form"
          :form="form"
          @submit="handleSubmit"
        >
          <a-col :span="24">
            <a-form-item
              :wrapper-col="{ span: 24 }"
            >
              <common-card-input
                :rows="15"
                v-decorator="['iccids', {
                  initialValue: { data: this.iccids },
                  rules: [{ validator: checkIccids }],
                }]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="执行方式">
              <a-radio-group
                v-decorator="['execute_mode', {
                  initialValue: 'immediate',
                  rules: [{ required: true, message: '请选择执行方式' }],
                }]"
                @change="handleExecuteModeChange"
              >
                <a-radio value="immediate">立即断网</a-radio>
                <a-radio value="scheduled">定时断网</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>

          <a-col :span="24" v-if="executeMode === 'scheduled'">
            <a-form-item label="执行时间">
              <a-date-picker
                style="width: 100%;"
                show-time
                format="YYYY-MM-DD HH:mm"
                :disabled-date="disabledDate"
                :disabled-time="disabledTime"
                v-decorator="['scheduled_execute_at', {
                  rules: [
                    { required: true, message: '请选择执行时间' },
                    { validator: checkScheduledAt },
                  ]
                }]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item label="备注">
              <a-textarea
                v-decorator="['remark', {
                  rules: [
                    { max: 200, message: '最多200个字符' },
                  ]
                }]"
                :auto-size="{ minRows: 3, maxRows: 5 }"
              />
            </a-form-item>
          </a-col>
        </a-form>
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { netDownSimCards } from '@/api/batch_operation'
import CommonCardInput from '@/components/CardInput/Common'

export default {
  name: 'BatchOperationNetDownSimCards',
  components: { CommonCardInput },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    iccids: {
      type: Array,
      default() {
        return []
      }
    },
    agentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'net_down_sim_cards' }),
      submitting: false,
      executeMode: 'immediate'
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleExecuteModeChange(e) {
      this.executeMode = e.target.value
      if (this.executeMode !== 'scheduled') {
        this.form.setFieldsValue({ scheduled_execute_at: undefined })
      }
    },

    disabledDate(current) {
      return current && current < this.$moment().startOf('day')
    },

    disabledTime(current) {
      if (!current) {
        return {}
      }
      const now = this.$moment()
      if (!current.isSame(now, 'day')) {
        return {}
      }
      const disabledHours = []
      for (let i = 0; i < now.hour(); i++) {
        disabledHours.push(i)
      }
      const disabledMinutes = (selectedHour) => {
        if (selectedHour > now.hour()) {
          return []
        }
        const minutes = []
        for (let i = 0; i <= now.minute(); i++) {
          minutes.push(i)
        }
        return minutes
      }
      return {
        disabledHours: () => disabledHours,
        disabledMinutes
      }
    },

    checkIccids(rule, value, callback) {
      if (!value || !value.inputValue) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请输入卡号')
        return
      }

      if (value.validateStatus === 'error') {
        callback(value.errorMsg)
        return
      }

      // eslint-disable-next-line standard/no-callback-literal
      callback()
    },

    checkScheduledAt(rule, value, callback) {
      if (this.executeMode !== 'scheduled') {
        callback()
        return
      }
      if (!value) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('请选择执行时间')
        return
      }
      if (!value.isAfter(this.$moment())) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('执行时间必须晚于当前时间')
        return
      }
      callback()
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          const data = {
            remark: values.remark,
            iccids: values.iccids.data,
            agent_id: this.agentId
          }
          if (values.execute_mode === 'scheduled' && values.scheduled_execute_at) {
            data.scheduled_execute_at = values.scheduled_execute_at.format('YYYY-MM-DD HH:mm:00')
          }
          netDownSimCards(data).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
              const isScheduled = values.execute_mode === 'scheduled'
              this.$success({
                title: '提交成功',
                content: (
                  <div>
                    <p>
                      {isScheduled
                        ? `已预约于 ${data.scheduled_execute_at} 执行断网，可在卡详情【定时任务】中查看或取消`
                        : '操作成功，具体操作结果请至 【系统查询】-【批量操作查询】 查看'}
                    </p>
                  </div>
                )
              })
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
